import { gql } from "@apollo/client";

const UPDATE_USER_SPORT = gql`
  mutation updateUserSport($id: Int!, $club: Int, $platformCoach: Int, $team: String) {
    updateUserSport(
      updateUserSportInput: { id: $id, club: $club, platformCoach: $platformCoach, team: $team }
    ) {
      id
      team
    }
  }
`;
export default UPDATE_USER_SPORT;
